import { render, staticRenderFns } from "./CausesRejectedFormatter.vue?vue&type=template&id=1f71e40a&functional=true"
import script from "./CausesRejectedFormatter.vue?vue&type=script&lang=js"
export * from "./CausesRejectedFormatter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports